// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtCardMedBenCardReplaceResultModel {
    static getAttributeTypeMap() {
        return ExtCardMedBenCardReplaceResultModel.attributeTypeMap;
    }
}
ExtCardMedBenCardReplaceResultModel.discriminator = undefined;
ExtCardMedBenCardReplaceResultModel.additionalProperties = false;
ExtCardMedBenCardReplaceResultModel.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "orderReferenceNumber",
        "baseName": "orderReferenceNumber",
        "type": "string"
    },
];
//# sourceMappingURL=extCardMedBenCardReplaceResultModel.js.map